<template>
  <div class="toolbar" :class="{'toolbar--separate': hasBorder}">
    <slot name="toolbar-image"></slot>
    <slot name="toolbar-text"></slot>
    <slot name="toolbar-action"></slot>
  </div>
</template>

<script>
export default {

  name: 'StepCardToolbar',
  props: {
    hasBorder: {
      type:Boolean,
      required: false
    },
  },
}
</script>

<style lang="scss">

.toolbar {
  position: relative;
  line-height: normal;

  &__text {
    margin-left: 10px;
    color: #545354;
    font-size: 13px;
  }

  &__link {
    &,
    &:link,
    &:visited {
      font-size: 14px;
      text-decoration: none;
    }

    &:not(:last-child) {
      margin-right: 15px;
    }
  }

  &--separate {
    border-bottom: 1px solid #e7e7e7;
    padding-bottom: 14px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/step/StepCardToolbar.vue